// POST /api/admin/stripe/external-accounts/reconcile
export interface StripeExternalAccountsReconcileResponse {
  jobId: string;
}

/**
 * Result returned by the Hangfire backfill job
 * (IStripeConnectService.BackfillReconcileExternalAccountsAsync).
 *
 * NOTE: GET /api/jobs/{jobId} does NOT currently expose this payload — it only
 * returns state/timing/exception. The reconciliation counters become visible in
 * the UI only once the backend starts returning the Hangfire job result.
 */
export interface StripeExternalAccountReconciliationResultDto {
  /** Contractors with a Stripe Connect account considered. */
  totalConsidered: number;
  /** External accounts examined. */
  scanned: number;
  /** Orphaned external accounts deleted in Stripe. */
  deleted: number;
  /** Accounts kept because they are the current default. */
  keptDefault: number;
  /** Accounts kept because they are still tracked locally. */
  keptTracked: number;
  /** Deletions that failed. */
  failed: number;
  /** External account ids (ba_...) whose deletion failed. */
  failedExternalAccountIds: string[];
  /** Contractors whose reconciliation failed completely. */
  failedContractorIds: string[];
}
